import React from 'react'
import Image from '../components/image'

const PageBanner = ({ title, image, shop = false, restructuring }) => {
    return (
        <div className={`PageBanner${shop ? '--shop' : ''} ${restructuring !== undefined ? `${restructuring}__banner` : ''}`}>
            <div className="Container">
                <div className="PageBanner__wrap">
                    <div className={`${shop ? 'col-5 ' : ''}PageBanner__title`}>
                        <h1>{title}</h1>
                    </div>
                    <div className={`PageBanner__image${shop ? '--shop col-7' : ''}`}>
                        <Image source={image} imgClass='PageBanner__image__img' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageBanner